import React, { useContext, useEffect, useState } from "react";
import { Button, ColorPicker, Form, Input, Space, Tag, Typography } from "antd";
import { IconPicker } from "react-fa-icon-picker";
import ModalTags from "../GeoUnit/ModalTags";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import TextEditorModal from "./../Place/TextEditorModal";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const EventForm = () => {
    const [form] = Form.useForm();
    // state
    const [isEditSelected, setIsEditSelected] = useState(false);
    const [dateRange, setDateRange] = useState([]);
    // context
    const {
        selectedEventId,
        setEventTags,
        setTextEditorShow,
        setTextEditorHTML,
        eventTitle,
        setEventTitle,
        eventLinks,
        setEventLinks,
        eventLinkColor,
        setEventLinkColor,
        eventLinkIcon,
        setEventLinkIcon,
        eventLinkUrl,
        setEventLinkUrl,
        setEventMedia,
        setEventCover,
        setEventStartDate,
        eventStartDate,
        setEventEndDate,
        eventEndDate,
        eventLinktitleUrl,
        setEventLinktitleUrl,
    } = useContext(context);
    // useEffect
    useEffect(() => {
        if (selectedEventId) {
            http.get(`${config.parkopoloApi}/api/Event/${selectedEventId}`)
                .then((res) => {
                    setEventLinks(res.data.result.links);
                    setEventTitle(res.data.result.title);
                    setEventTags(res.data.result.tags);
                    setTextEditorHTML(res.data.result.data);
                    setEventCover([res.data.result.coverPic]);
                    setEventMedia(res.data.result.media);
                    setEventStartDate(res.data.result.date.start);
                    setEventEndDate(res.data.result.date.end);
                    setDateRange([
                        res.data.result.date.start,
                        res.data.result.date.end,
                    ]);
                })
                .catch((err) => {
                    console.log(err);
                });
            setIsEditSelected(true);
        } else {
            setDateRange([new Date(), new Date()]);
        }
    }, []);

    // functions
    const handleDeleteLink = (url) => {
        const links = eventLinks.filter((link) => link.url !== url);
        setEventLinks(links);
    };
    const handleTitleChange = (e) => {
        setEventTitle(e.target.value);
    };
    const handleColorChange = (color) => {
        setEventLinkColor(color);
    };
    const handleIconChange = (e) => {
        setEventLinkIcon(e);
    };
    const onUrlChange = (e) => {
        setEventLinkUrl(e.target.value);
    };
    const onUrlTitleChange = (e) => {
        setEventLinktitleUrl(e.target.value);
    };
    const handleAddLink = () => {
        const color = document.querySelector(
            ".ant-color-picker-trigger-text"
        ).innerText;
        const newLink = {
            name:eventLinktitleUrl,
            url: eventLinkUrl,
            color: color,
            icon: eventLinkIcon,
        };
        setEventLinks([...eventLinks, newLink]);
        setEventLinkUrl(null);
        setEventLinkColor(null);
        setEventLinkIcon(null);
    };
    const handleChangeDate = (value) => {
        setEventStartDate(value[0]?.toDate?.().toString());
        setEventEndDate(value[1]?.toDate?.().toString());
        setDateRange(value);
    };

    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                gap: "15px",
                margin: "15px",
            }}
        >
            <Form
                layout="vertical"
                form={form}
                name="control-hooks"
                style={{
                    width: "100%",
                }}
            >
                <div style={{ display: "flex", gap: "2rem" }}>
                    <Form.Item
                        name="عنوان"
                        label="عنوان"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {eventTitle}
                        </h4>
                        <input
                            className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                            type="text"
                            value={isEditSelected ? eventTitle : null}
                            onChange={handleTitleChange}
                            placeholder="عنوان را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item
                        name="تاریخ"
                        label="تاریخ شروع و پایان"
                        style={{ width: "100%" }}
                    >
                        <div style={{ display: "none", gap: "2rem" }}>
                            <Typography.Paragraph>
                                {eventStartDate}
                            </Typography.Paragraph>
                            <Typography.Paragraph>
                                {eventEndDate}
                            </Typography.Paragraph>
                        </div>
                        <DatePicker
                            value={dateRange}
                            onChange={handleChangeDate}
                            range
                            dateSeparator=" تا "
                            plugins={[<DatePanel position="right" />]}
                            calendar={persian}
                            locale={persian_fa}
                            calendarPosition="bottom-right"
                        />
                    </Form.Item>
                </div>
                <div
                    style={{
                        display: "flex",
                        gap: "30px",
                        alignItems: "center",
                    }}
                >
                    <Form.Item
                        name="عنوان لینک"
                        label="عنوان لینک"
                        style={{ width: "100%" }}
                    >
                        <Input
                            value={eventLinktitleUrl}
                            onChange={onUrlTitleChange}
                            placeholder="عنوان لینک را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item
                        name="آدرس لینک"
                        label="آدرس لینک"
                        style={{ width: "100%" }}
                    >
                        <Input
                            value={eventLinkUrl}
                            onChange={onUrlChange}
                            placeholder="آدرس لینک را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item label="آیکون لینک" name="آیکون لینک">
                        <IconPicker
                            value={eventLinkIcon}
                            buttonStyles={{
                                padding: "0 2.5rem",
                                border: "1px solid silver",
                                width: "100%",
                            }}
                            onChange={(e) => handleIconChange(e)}
                        />
                    </Form.Item>
                    <Form.Item label="رنگ لینک" name="رنگ">
                        <ColorPicker
                            value={eventLinkColor}
                            onChange={handleColorChange}
                            style={{
                                padding: "1.5rem",
                                width: "100%",
                            }}
                            showText
                        />
                    </Form.Item>
                    <Button
                        onClick={handleAddLink}
                        disabled={
                            !eventLinkColor || !eventLinkIcon || !eventLinkUrl
                        }
                    >
                        اضافه کردن لینک جدید
                    </Button>
                </div>
                <Space wrap>
                    {eventLinks.map((link) => {
                        return (
                            <Tag
                                color="blue"
                                closeIcon
                                key={link.url}
                                onClose={() => handleDeleteLink(link.url)}
                            >
                                {link.url}{" "}
                                <i
                                    className={`fa ${link.icon
                                        .split(/(?=[A-Z])/)
                                        .map((word) => word.toLowerCase())
                                        .join("-")}`}
                                    style={{ fontSize: "10px" }}
                                />
                            </Tag>
                        );
                    })}
                </Space>

                <Form.Item name="تگ" label="تگ ها">
                    <div>
                        <ModalTags section="events" />
                    </div>
                </Form.Item>
                <Form.Item name="ویرایشگر متن">
                    <Button
                        onClick={() => setTextEditorShow(true)}
                        type="primary"
                    >
                        ویرایشگر متن
                    </Button>
                </Form.Item>
            </Form>
            <TextEditorModal />
        </div>
    );
};

export default EventForm;
